import PropTypes from 'prop-types';
import { BsCaretUpFill, BsCaretDownFill } from 'react-icons/bs';

const SortIndicator = ({ active = false, direction }) => (
	<span className="inline-flex flex-col items-center -space-y-1">
		<BsCaretUpFill
			className={`w-2.5 h-2.5 transition-colors ${
				active && direction === 'asc' ? 'text-primary-500' : 'text-bgBase-600'
			}`}
		/>
		<BsCaretDownFill
			className={`w-2.5 h-2.5 transition-colors ${
				active && direction === 'desc' ? 'text-primary-500' : 'text-bgBase-600'
			}`}
		/>
	</span>
);

SortIndicator.propTypes = {
	active: PropTypes.bool,
	direction: PropTypes.oneOf(['asc', 'desc']),
};

export default SortIndicator;
